import React from "react";
import Mainpage from "./Main/Mainpage";
import "./Home.css";

const Home = () => {
  return (
    <div className="home-container" id="home">
      <Mainpage />
    </div>
  );
};

export default Home;
